import * as React from 'react';
import _ from 'lodash';
import { Divider, Icon, Label, Popup, Table } from 'semantic-grab-ui/src';
import { TwoCellRow } from 'components/custom';
import { Campaign } from 'types/ts/campaigns';
import { NodeWarning } from 'types/trident-campaigns';
import LimitShow from './LimitShow';
import SubScenarioShow from './SubScenarioShow';
import WarningList from './WarningList';
import {getTreatmentIdsFromScenarioNode} from 'omega-rtc/utils/trident-node-utils';
import LimitHitWarning from 'components/form/trident-campaigns/LimitHitWarning';
import moment from 'moment';
import {DATE_FORMAT} from './constraints'

interface Props {
  model: Campaign,
  setRef: Function,
  currentNode: string,
  listRuleTypes: Object,
  hideUsage?: boolean,
  warnings?: NodeWarning,
  viewType?: "edit" | "view",
}

// ScenariosShow shows the content of a scenarios node (with one or multiple scenarios)
export default class ScenariosShow extends React.Component<Props> {
  render() {
    const { model, currentNode, listRuleTypes, viewType } = this.props;
    const targetUserType = _.get(model, 'targetUserType', '');
    const scenarios = _.get(model, `nodes[${currentNode}].data.scenarios`, []);
    const warnings = _.get(this.props.warnings, 'data.meta', []);
    const totalUsage = _.get(model, `usage.scenarioUsages[${currentNode}].total`, 0)
    const lastUsage = totalUsage > 0
      ? moment(_.get(model, `usage.scenarioUsages[${currentNode}].lastUsage`)).format(DATE_FORMAT)
      : undefined

    const campaignStartTime = _.get(model, 'startTime')
    const usageTrackingCutoffDate = moment('2025-02-13T00:00:00Z'); // Cutoff date when usage tracking table has been shifted to DDB
    const shouldDisplayUsageWarning = campaignStartTime && campaignStartTime.isBefore(usageTrackingCutoffDate);

    return (
      <div>
        <Table striped>
          <Table.Body>
            {
              !_.isEmpty(warnings) &&
              <TwoCellRow
                firstCell="⚠️⚠️⚠️"
                secondCell={
                  <WarningList warnings={warnings} />
                }
              />
            }
            <TwoCellRow
              firstCell="Start"
              secondCell={`${_.get(model.nodes[currentNode], 'data.meta.startTimePretty', '')}`}
            />
            <TwoCellRow
              firstCell="End"
              secondCell={`${_.get(model.nodes[currentNode], 'data.meta.endTimePretty', '')}`}
            />
            {
              !this.props.hideUsage &&
              <React.Fragment>
                <TwoCellRow
                  firstCell="Usage today"
                  secondCell={`${_.get(model, `usage.scenarioUsages[${currentNode}].daily`, 0)}`}
                />
                <TwoCellRow
                  firstCell="Usage total"
                  secondCell={
                    <div style={{display: 'flex'}}>
                      {totalUsage}
                      {shouldDisplayUsageWarning &&
                        <span style={{marginLeft: 3}}>
                          <Popup trigger={<Icon name="info circle"/>}
                                 content="This number may be lower than the actual figures because the usage count data for all campaigns before February 13 2025 has been reset. For accurate figures, please reach out to Trident Oncall via #trident-questions."
                                 size="mini"
                          />
                      </span>
                      }
                      <div style={{marginLeft: '10px'}}>
                        <LimitHitWarning content={'Total limit hit'}
                                         usage={_.get(model, `usage.scenarioUsages.${currentNode}.total`)}
                                         limit={_.result( _.find( _.get(model, `nodes.${currentNode}.limits`), (obj) => obj.per === "total" ), "limit")} />
                      </div>
                    </div>
                  }
                />
                {!_.isEmpty(lastUsage) &&
                  <TwoCellRow
                    firstCell="Last Usage"
                    secondCell={lastUsage}
                  />
                }
              </React.Fragment>

            }
            <TwoCellRow
              firstCell="Limits"
              secondCell={<LimitShow limits={_.get(model.nodes[currentNode], 'limits', [])} />}
            />
          </Table.Body>
        </Table>


        {
          _.map(scenarios, (s, index) => {
            const tmIDs = getTreatmentIdsFromScenarioNode(model, currentNode, index+1);
            return (
              <div>
                <Label>Scenario {index+1}</Label><span style={{color:'#00b140'}} > { viewType !== "edit" && tmIDs.length > 0 ? `(tm: ${_.join(tmIDs, ',')})` : ''}</span>
                <SubScenarioShow
                  scenario={s}
                  targetUserType={targetUserType}
                  setRef={this.props.setRef}
                  listRuleTypes={listRuleTypes}
                />

                <Divider/>
              </div>
            )
          })
        }
      </div>
    );
  }
}
